var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { apiBase, cdnBase } from "../conf/live";
import { get } from "../util/ajax";
import { report } from "../util/mdap";
import { measureTime } from "../util/measure-time";
var API = /** @class */ (function () {
    function API(env, isMainland) {
        var _this = this;
        this.getTranslationFromAPI = function (_a) {
            var _b;
            var language = _a.language, type = _a.type, id = _a.id, keys = _a.keys, hash = _a.hash;
            var data = (_b = {}, _b[type + "_id"] = id, _b.language = language, _b.keys = keys, _b.hash = hash, _b);
            return get(_this.apiBase + "/transify", data);
        };
        this.getTranslationFromCDN = function (args) {
            var fileName = _this.getFileName(args);
            return get(_this.cdnBase + "/" + fileName);
        };
        var cn = this.isCN(isMainland);
        this.apiBase = apiBase(env, cn);
        this.cdnBase = cdnBase(env, cn);
    }
    API.prototype.init = function (language, mod) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var args, data, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        args = {
                            language: language,
                            projectId: mod.projectId,
                            resources: (_a = mod.resources) === null || _a === void 0 ? void 0 : _a.join(';'),
                            collections: (_b = mod.collections) === null || _b === void 0 ? void 0 : _b.join(';')
                        };
                        return [4 /*yield*/, get(this.apiBase + "/init", args)];
                    case 1:
                        data = _c.sent();
                        report('29e8db23bebcc026a4d7046e47218c1f', 10000);
                        return [2 /*return*/, data.body || {}];
                    case 2:
                        e_1 = _c.sent();
                        report('a1fe13e807065f3490326d2a34936ec6', 0);
                        return [2 /*return*/, {}];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    API.prototype.getFileName = function (_a) {
        var type = _a.type, language = _a.language, id = _a.id, hash = _a.hash;
        // 取type的第一个字符
        var t = type[0] + "_" + id + "_" + language.toLowerCase();
        return hash ? t + "_" + hash + ".js" : t + ".json";
    };
    API.prototype.isCN = function (isMainland) {
        return isMainland !== undefined ? isMainland : window.location.host.slice(-2) === 'cn';
    };
    __decorate([
        measureTime('5d42f2badb8e75f819c0b005535c8dc3')
    ], API.prototype, "init", null);
    return API;
}());
export { API };
//# sourceMappingURL=index.js.map